// Id aleatorio impredecible. crypto.randomUUID solo existe en contextos seguros (https o
// localhost); al abrir el sitio por la IP de la red local (http) no está y reventaba la
// página, así que ahí se arma con getRandomValues.
export function randomId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
